<ng-container *transloco="let convert;">
  <div class="border border-dark batch-posting-shell">
    <div class="wrapper">
      <div class="header">
        <h2 class="fw-bold" tabindex="0" data-test-id="app-csv-dashboard-widget-e-header-text">{{convert('sellModule.manageInventory.csvDashBoardTranslations.textManageFileStatusUpdates')}}</h2>
      </div>
      @if (updateFileStatus) {
        <div class="d-flex flex-column align-custom">
          @if (updateFileStatus) {
            <span><strong>{{ convert('sellModule.manageInventory.csvDashBoardTranslations.textFileStatusUpdated') }}</strong></span>
          }
        </div>
      }
      <br>
      </div>
      <form class="body" name="updateWidgetForm" [formGroup]="updateWidgetForm">
        <div class="form-group date-label mb-0">
          <label class="control-label">{{convert('sellModule.manageInventory.csvDashBoardTranslations.textFileStatus')}}</label>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <div class="select-wrapper">
              <select formControlName="fileStatus" id="fileStatus" class="custom-select wrapText"
                aria-label="selectFileStatus" (change)="setSelectedFileStatus()">
                <option [ngValue]="'default'">{{ convert('sellModule.posting.descriptionForm.textSelect') }}</option>
                @if (fileStatuses) {
                  @for (status of fileStatuses; track status) {
                    <option [ngValue]="status">{{ status }}</option>
                  }
                }
              </select>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group date-label mb-0">
            <label class="control-label">{{convert('sellModule.manageInventory.csvDashBoardTranslations.textStartDate')}}</label>
          </div>
          <div class="flex-grow-1">
            <div class="form-group d-flex date-group">
              <input
                type="text"
                id="statusDate"
                class="form-control form-input"
                formControlName="date"
                [formControl]="statusDateFormControl"
                [class.is-invalid]="!statusDateValid"
                [minDate]="statusMinDate"
                [startDate]="statusStartDate"
                (dateSelect)="updateStatusDate($event)"
                [value]="displayStatusDate"
                #statusDp="ngbDatepicker"
                ngbDatepicker
                #dpStatusDate
                [startDate]="statusStartDate"
                (input)="updateStatusDate(dateFormatter.parse(dpStatusDate.value))"
                container="body"
                [attr.aria-label]="convert('sellModule.manageInventory.csvDashBoardTranslations.ariaLabelStartDate')"
                [placeholder]="dateFormatter.placeholderText()"
                (closed)="focusStatusDateCalendar()"
                [appTrack]="fromDateTrack.input"
                />
              <button
                #statusDateCalendar
                class="btn btn-outline-primary calendar-button"
                (click)="statusDp.toggle()"
                [attr.aria-expanded]="statusDp.isOpen()"
                [attr.aria-label]="convert('sellModule.manageInventory.csvDashBoardTranslations.ariaLabelStartDate')"
                [style.border-color]="!statusDateValid ? 'red' : ''"
                [appTrack]="fromDateTrack.button"
                >
                <i class="allycon-calendar" aria-hidden="true"></i>
              </button>
            </div>
          </div>
          <div class="form-group date-label mb-0">
            <label class="control-label">{{convert('sellModule.manageInventory.csvDashBoardTranslations.textStartTime')}}</label>
          </div>
          <ngb-timepicker formControlName="time" [meridian]="true" [spinners]="false">
          </ngb-timepicker>
        </div>
        <div class="error-message from-date-error" aria-atomic="true" aria-live="polite" role="alert">
          @if (!statusDateValid) {
            <div>
              <strong>{{ convert('sellModule.manageInventory.csvDashBoardTranslations.textEnterValidStartDate') }}</strong></div>
            }
          </div>
          <div class="py-3">
            <ng-container>
              <button
                (click)="processFileUpdate()"
                allytm-click-tagged="false"
                data-test-id="app-batch-posting-shell-e-upload-button"
                class="upload-button">
                Update File Status
              </button>
            </ng-container>
          </div>
          <div>
            @if (appLoading) {
              <div class="d-flex justify-content-center align-items-center spinner-container tab-spinner-height mb-3">
                <app-spinner></app-spinner>
              </div>
            }
          </div>

          <app-error-modal></app-error-modal>
        </form>
      </div>
    </ng-container>
